import { render } from "./_MessengerNotifications.vue?vue&type=template&id=460be554&ts=true"
import script from "./_MessengerNotifications.vue?vue&type=script&lang=ts"
export * from "./_MessengerNotifications.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/askom/io.askom.portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__